export default {
    menuAreClienteSelect: [],
    loadingAction: false,
}
